module.exports = __webpack_public_path__ + "img/gb9123_34.prt.54531de1.jpg";